import { ItemCombobox } from '@models-global/model-combobox-item';

export enum CEClaimsProcessor {
  SELF = 'self',
  THIRD_PARTY = 'third_party'
}

export enum CEPharmacySystem {
  LIBERTY = 'liberty'
}

export const CE_PHARMACY_SYSTEM_MAP: ReadonlyMap<CEPharmacySystem, string> =
  new Map([[CEPharmacySystem.LIBERTY, 'Liberty']]);

export const CE_PHARMACY_SYSTEM_OPTIONS: ReadonlyArray<ItemCombobox> = [
  ...CE_PHARMACY_SYSTEM_MAP.entries()
].map(([value, text]) => ({ value, text }));

export enum CEOutgoingIntegrationType {
  OREGON_STATE_MEDICAID = 'oregon_state_medicaid'
}

export const CE_OUTGOING_INTEGRATION_TYPE_MAP: ReadonlyMap<
  CEOutgoingIntegrationType,
  string
> = new Map([
  [
    CEOutgoingIntegrationType.OREGON_STATE_MEDICAID,
    'Oregon State Medicaid Repository'
  ]
]);

export const CE_OUTGOING_INTEGRATION_TYPE_OPTIONS: ReadonlyArray<ItemCombobox> =
  [...CE_OUTGOING_INTEGRATION_TYPE_MAP.entries()].map(([value, text]) => ({
    value,
    text
  }));

export enum CoveredEntityServiceType {
  CLEARINGHOUSE = 1,
  REPOSITORY = 2,
  MFP = 3,
  REBATE = 4,
  MFRSUBMISSION = 5,
  MFRSUBMISSIONDISPUTEEVIDENCE = 6
}

export const CE_SERVICE_TYPE_MAP: ReadonlyMap<
  CoveredEntityServiceType,
  string
> = new Map([
  [CoveredEntityServiceType.CLEARINGHOUSE, '340B Clearinghouse'],
  [CoveredEntityServiceType.REPOSITORY, '340B Repository']
]);

export const CE_SERVICE_TYPE_OPTIONS: ReadonlyArray<ItemCombobox> = [
  ...CE_SERVICE_TYPE_MAP.entries()
].map(([value, text]) => ({
  value,
  text
}));
